import React, { memo, useEffect } from 'react';
import { Box, Image } from '@chakra-ui/react';
import logoTextSrc from '../assets/logo-text-final.svg?v=2';
import logoIconSrc from '../assets/logo-final.svg?v=2';

const Logo = ({ variant = 'full', size = 'md', ...props }) => {
  const sizes = {
    sm: variant === 'full' ? { height: '32px', width: '180px' } : { height: '32px', width: '32px' },
    md: variant === 'full' ? { height: '40px', width: '220px' } : { height: '40px', width: '40px' },
    lg: variant === 'full' ? { height: '52px', width: '280px' } : { height: '52px', width: '52px' },
  };

  const logoSrc = variant === 'full' ? logoTextSrc : logoIconSrc;
  
  useEffect(() => {
    console.log('Logo component rendering:', { variant, size, src: logoSrc });
  }, [variant, size, logoSrc]);

  return (
    <Box 
      {...sizes[size]} 
      {...props} 
      display="flex" 
      alignItems="center" 
      justifyContent="flex-start"
      position="relative"
    >
      <Image
        src={logoSrc}
        alt="Emailed"
        height="100%"
        width="100%"
        objectFit="contain"
        style={{ cursor: 'pointer' }}
        onError={(e) => {
          console.error('Logo failed to load:', e);
          console.error('Attempted src:', logoSrc);
          // Add a fallback text
          e.target.style.display = 'none';
          e.target.parentElement.textContent = 'emailed';
        }}
      />
    </Box>
  );
};

export default memo(Logo);
